import { createStackNavigator } from '@react-navigation/stack'
import { lazy } from 'react'
import { Header } from '../../comps/Header'
import { DeleteBeneficiaryVerifyScreen } from '../../screens/DomesticMoneyTransfer/BeneficiaryList/DeleteBeneficiaryList'
import { DMRTransactionsScreen } from '../../screens/DomesticMoneyTransfer/DMRTransactionsScreen'
import MoneyTransferHomeScreen from '../../screens/DomesticMoneyTransfer/HomeScreen'
import { SelectLoginTypeScreen } from '../../screens/DomesticMoneyTransfer/SelectLoginTypeScreen'
import { SplittedTnxListScreen } from '../../screens/DomesticMoneyTransfer/SplittedTnxListScreen'
import { SplitTransactionStatusScreen } from '../../screens/DomesticMoneyTransfer/SplitTransactionStatusScreen'
import { LoadInitialsScreen } from '../../screens/LoadInitialsScreen'
import { Screens } from '../Screens'
import { HEADER_TITLE } from './ScreenHeaders'

const LoginScreen = lazy(() => import('../../screens/DomesticMoneyTransfer/Login'))
const EnterCustomerDetails = lazy(() => import('../../screens/DomesticMoneyTransfer/EnterCustomerDetails'))
const BeneficiaryForm = lazy(() => import('../../screens/DomesticMoneyTransfer/EnterBeneficiaryDetails'))
const NoBeneficiaryFound = lazy(() => import('../../screens/DomesticMoneyTransfer/NoBeneficiaryFound'))
const TransactionSuccessScreen = lazy(() => import('../../screens/DomesticMoneyTransfer/TransactionSuccessful'))
const BeneficiaryList = lazy(() => import('../../screens/DomesticMoneyTransfer/BeneficiaryList'))
const TransferFundScreen = lazy(() => import('../../screens/DomesticMoneyTransfer/TransferFundScreen'))
const OtpScreen = lazy(() => import('../../screens/DomesticMoneyTransfer/Otp'))
const SearchIFSC = lazy(() => import('../../screens/DomesticMoneyTransfer/SearchIFSC'))
const ScanFaceOrFingerprintScreen = lazy(
  () => import('../../screens/DomesticMoneyTransfer/ScanFaceOrFingerprintScreen'),
)

const EnterCustomerAadhaarCardScreen = lazy(
  () => import('../../screens/DomesticMoneyTransfer/EnterCustomerAadhaarCardScreen'),
)

export const DomesticMoneyTransferStack = () => {
  const Stack = createStackNavigator()
  return (
    <Stack.Navigator
      screenOptions={{
        headerTitle: HEADER_TITLE,
        header: Header,
      }}>
      <Stack.Screen name={Screens.LOAD_INITIALS} component={LoadInitialsScreen} />
      <Stack.Screen name={Screens.DOMESTIC_MONEY_TRANSFER_HOME_SCREEN} component={MoneyTransferHomeScreen} />
      <Stack.Screen name={Screens.DOMESTIC_MONEY_TRANSACTIONS_SCREEN} component={DMRTransactionsScreen} />
      <Stack.Screen name={Screens.DOMESTIC_MONEY_TRANSFER_LOGIN} component={LoginScreen} />
      <Stack.Screen name={Screens.SELECT_LOGIN_TYPE_SCREEN} component={SelectLoginTypeScreen} />
      <Stack.Screen name={Screens.DOMESTIC_MONEY_TRANSFER_OTP} component={OtpScreen} />
      <Stack.Screen name={Screens.SCAN_FINGERPRINT} component={ScanFaceOrFingerprintScreen} />
      <Stack.Screen name={Screens.ENTER_AADHAAR_CARD} component={EnterCustomerAadhaarCardScreen} />
      <Stack.Screen name={Screens.ENTER_CUSTOMER_DETAILS} component={EnterCustomerDetails} />
      <Stack.Screen name={Screens.NO_BENEFICIARY_FOUND} component={NoBeneficiaryFound} />
      <Stack.Screen name={Screens.ENTER_BENEFICIARY_DETAILS} component={BeneficiaryForm} />
      <Stack.Screen name={Screens.BENEFICIARY_LIST_SCREEN} component={BeneficiaryList} />
      <Stack.Screen name={Screens.TRANSFER_FUND} component={TransferFundScreen} />
      <Stack.Screen name={Screens.TRANSACTION_SUCCESS_SCREEN} component={TransactionSuccessScreen} />
      <Stack.Screen name={Screens.SPLIT_TRANSACTION_SUCCESS_SCREEN} component={SplitTransactionStatusScreen} />
      <Stack.Screen name={Screens.SEARCH_IFSC} component={SearchIFSC} />
      <Stack.Screen name={Screens.SPLITTED_TNX_LIST} component={SplittedTnxListScreen} />
      <Stack.Screen name={Screens.DELETE_BENELIST} component={DeleteBeneficiaryVerifyScreen} />
    </Stack.Navigator>
  )
}
